<div class="bg-image">

    <br>

    <mat-card-content>

        <div class="row"
            style="padding-top: 2px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
            <div class="td-col-md-2" style="width: 5%;" class="mobileview"></div>
            <div class=" themecard card mobileviewmain" style="width: 90%;border-width: 2px; ">

                <mat-card>
                    <mat-card tabindex="0" style="color:white; background-color: #11446f; border: 1px solid #f1b122;">
                        <mat-card-content title="RESOURCES">RESOURCES</mat-card-content>
                    </mat-card>
                    <div class="card">

                        <div class="card-body">
                            <p class="card-text p-1">

                                MyJax Community Connect provides access to published reports and presentations
                                highlighting the City of Jacksonville’s quality of life investments. This page also
                                includes reference resources and dashboard navigation tools, such as the Quick Reference
                                Guide. Click on the links below to view these resources and reports.
                                <br>
                                <br>
                                <strong style="text-decoration: underline;"> Disclaimer:</strong>

                                Information contained on this site is for general information purposes only. Every
                                effort has been made to provide information that is current and accurate. Nevertheless,
                                inadvertent data errors may occur, and the data on this site may not show a complete
                                picture of the City of Jacksonville’s quality-of-life funding investments. Most City of
                                Jacksonville staff salaries are not included in this analysis.

                            </p>

                            <p class="card-text p-1">
                                <strong style="text-decoration: underline;" title="Reference"> Reference: </strong>
                            </p>
                            <div>
                                <ul>
                                    <li> <a tabindex="0" alt="Quick Reference Guide (Click here to view)"
                                            title="Quick Reference Guide (Click here to view)"
                                            (click)="OpenquickreferenceguidePDF()"
                                            aria-label="Link to view Quick Reference Guide (Click here to view)"
                                            style="cursor: pointer;text-decoration: underline;">Quick Reference Guide
                                            (Click
                                            here to view)
                                        </a>
                                    </li>
                                    <li> <a tabindex="0" alt="Acronym/Abbreviation Key (Click here to view)"
                                            title="Acronym/Abbreviation Key (Click here to view)"
                                            (click)="OpenAbbrevitionPDF()"
                                            aria-label="Link to view Acronym/Abbreviation Key (Click here to view)"
                                            style="cursor: pointer;text-decoration: underline;">Acronym/Abbreviation Key
                                            (Click here
                                            to view)
                                        </a>
                                    </li>

                                </ul>
                            </div>
                            <br>
                            <div class="form-group row ">
                                <div class="col-md-4">
                                    <strong>Community Goal Framework</strong>
                                    <form [formGroup]="dropDownForm">
                                        <ng-multiselect-dropdown placeholder="ALL" id="CommunityFramework"
                                            name="communitygoal" [(ngModel)]="communitygoal"
                                            (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)"
                                            (onDeSelect)="onItemDeSelect($event)"
                                            (onDeSelectAll)="onUnSelectAll($event)"
                                            (onDropDownClose)="onDropDownClose()" [settings]="dropdownSettings"
                                            [data]="dropdownList" [formControl]="dropDownForm.controls['myItems']">
                                        </ng-multiselect-dropdown>
                                    </form>
                                </div>

                                <div class="col-md-4" style="padding:18px;">
                                    <form>
                                        <button (click)="ResetResourcesPage();" class="btn btn-danger btn-sm"
                                            mat-raised-button color="warn">Reset</button>
                                    </form>
                                </div>

                            </div>
                            <br>


                            <form novalidate #form="ngForm">
                                <table id="myTable">
                                    <thead>
                                        <tr class="header">
                                            <th style="width:45%;">Report/Presentation Name</th>
                                            <th style="width:25%;">Community Goal(s)</th>
                                            <th style="width:30%;">Date Published</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr *ngFor="let user of users ">
                                            <td>
                                                <a tabindex="0" alt="" title="{{user.name }}" href="{{user.links}}"
                                                    target="_blank" aria-label="Link to view City of Jacksonville Page"
                                                    style="cursor: pointer;text-decoration: underline;">{{user.name }}
                                                </a>
                                            </td>
                                            <td>{{user.communitygoal}}</td>
                                            <td>{{user.publisheddate}}</td>
                                            <!-- <td>{{user.links}}</td> -->
                                            <!-- <td>
                                                <a tabindex="0" alt="Jacksonville Community Framework"
                                                    title="Jacksonville Community Framework"
                                                    onclick="window.open('https://nonprofits.coj.net/Nonprofit-Investments-Summary-Report','_blank')"
                                                    aria-label="Link to view City of Jacksonville Page"
                                                    style="cursor: pointer;text-decoration: underline;">{{user.links}}
                                                </a>
                                            </td>  -->
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="form-group row">
                                    <div class="col-md-12" style="color:crimson; text-align:center;" tabindex="0">
                                        <br>
                                        <!-- {{message}} -->
                                    </div>
                                </div>
                            </form>


                            <p>
                        </div>

                    </div>



                </mat-card>









            </div>


        </div>


    </mat-card-content>








    <br>
    <br>
    <br>
    <br>
    <br>
    <br>


</div>